export default __webpack_public_path__ + "static/press_2-fad34021709938cdb532e0a3161daaed.jpg";